<template>
  <div class="flex flex-col">
    
    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6">Personal Information</p>
    
 
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
      <TextControl  :maxLength="30" ref="last_name" label="Last Name" fieldId="last_name" :required="true" v-model="form.last_name"/>
      <TextControl  :maxLength="30" ref="first_name" label="First Name" fieldId="first_name" :required="true" v-model="form.first_name" />
      <TextControl  :maxLength="30" ref="middle_name" label="Middle Name" fieldId="middle_name" :required="false" v-model="form.middle_name" />
      <TextControl  :maxLength="10" ref="suffix" label="Suffix" fieldId="suffix" :required="false" v-model="form.suffix" />
      <TextControl  :maxLength="8" ref="account_no" label="Account No." fieldId="account_no" required v-model="form.account_no" />
      <TextControl  :maxLength="15" ref="member_key" label="Member Key" fieldId="member_key" required v-model="form.member_key"/>
      <ComboBoxControl label="Nationality" fieldId="nationality" v-model="form.nationality" :required="true" :options="nationalityOptions"/>
      <TextControl :maxLength="30" ref="nationality_other" label="Others (please specify)" fieldId="nationality_other" :required="false" v-model="form.nationality_other" />
    </div>

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">IDs Presented</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Select an ID" fieldId="id_code" v-model="form.id_code" required :options="idOptions"/>
        <TextControl :maxLength="25" ref="id_number" label="ID Number" fieldId="id_number" required v-model="form.id_number"/>
        <DatePickerControl label="ID Expiry Date" fieldId="id_expiry" v-model="form.id_expiry" required />
        <TextControl :maxLength="15" ref="tin" label="TIN" fieldId="tin" v-model="form.tin" is_num/>
        <DatePickerControl label="Date of Birth" fieldId="birth_date" v-model="form.birth_date" required />
        <TextControl :maxLength="30" ref="birth_place" label="Place of Birth" fieldId="birth_place" required v-model="form.birth_place"/>
    </div>

    <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary mb-3 lg:mb-6 mt-6 lg:mt-12">Present Address</p>
    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Country" fieldId="country" v-model="form.country" :required="true" :options="countryOptions"/>
          <template v-if="isPhilippinesPre">
            <ComboBoxControl label="Province" fieldId="province" v-model="form.province" :required="true" :options="provinceOptions" :disabled="!form.country"/>
            <ComboBoxControl label="Municipality" fieldId="municipality" v-model="form.municipality" :required="true" :options="cityPreOptions" :disabled="!form.province" :is-loading="cityPreLoading"/>
          </template>

          <template v-else>
            <TextControl :max-length="40" label="Province" fieldId="province" v-model="form.province" :required="true"
            :disabled="!form.country" />
            <TextControl :max-length="40" label="Municipality" fieldId="municipality" v-model="form.municipality" :required="true" :disabled="!form.province" />
          </template>

        <TextControl :maxLength="30" ref="brgy" label="Brgy, Subdivision" fieldId="brgy" required v-model="form.brgy"/>
        <TextControl :maxLength="30" ref="street" label="Street" fieldId="street" required v-model="form.street"/>
        <TextControl :maxLength="10" ref="house_no" label="House No." fieldId="house_no" required v-model="form.house_no"/>
        <TextControl :maxLength="10" ref="zip_code" label="Zip Code" fieldId="zip_code" required v-model="form.zip_code" is_zip is_num/>
        <TextControl :maxLength="3" ref="residence" label="Years of Residency" fieldId="residence" required v-model="form.residence" is_zip is_num/>
    </div>

    <div class="flex items-center justify-start mb-3 lg:mb-6 mt-6 lg:mt-12">
        <p class="text-base lg:text-lg px-2 lg:px-3 lg:py-1 text-gray-600 font-medium border-l-4 lg:border-l-8 border-theme-secondary">Permanent Address</p>
        <div class="flex flex-row items-center justify-center ml-1 lg:ml-3">
          <input id="ad_same" type="checkbox" v-model="form.ad_same" class="w-3 h-3 lg:w-4 lg:h-4 cursor-pointer" style="accent-color: #016b00;">
          <label for="ad_same" class="text-xs lg:text-base ml-1 lg:ml-3">Same as Above</label>
        </div>
    </div>

    <div class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-2 lg:gap-4">
        <ComboBoxControl label="Country" fieldId="per_country" v-model="form.per_country" :required="!form.ad_same" :options="countryOptions" :disabled="form.ad_same"/>
          <template v-if="isPhilippinesPer">
            <ComboBoxControl label="Province" fieldId="per_province" v-model="form.per_province" :required="!form.ad_same" :options="provinceOptions" :disabled="!form.per_country || form.ad_same"/>
            <ComboBoxControl label="Municipality" fieldId="municipality" v-model="form.per_municipality" :required="!form.ad_same" :options="cityPerOptions" :disabled="!form.per_province || form.ad_same" :is-loading="cityPerLoading"/>
          </template>

          <template v-else>
            <TextControl :max-length="40" label="Province" fieldId="per_province" v-model="form.per_province" :required="!form.ad_same"
            :disabled="!form.per_country || form.ad_same" />
            <TextControl :max-length="40" label="Municipality" fieldId="per_municipality" v-model="form.per_municipality" :required="!form.ad_same" :disabled="!form.per_province || form.ad_same" />
          </template>

        <TextControl :maxLength="30" ref="per_brgy" label="Brgy, Subdivision" fieldId="per_brgy" :required="!form.ad_same" v-model="form.per_brgy" :disabled="form.ad_same"/>
        <TextControl :maxLength="30" ref="per_street" label="Street" fieldId="per_street" :required="!form.ad_same" v-model="form.per_street" :disabled="form.ad_same"/>
        <TextControl :maxLength="10" ref="per_house_no" label="House No." fieldId="per_house_no" :required="!form.ad_same" v-model="form.per_house_no" :disabled="form.ad_same"/>
        <TextControl :maxLength="10" ref="per_zip_code" label="Zip Code" fieldId="per_zip_code" :required="!form.ad_same" v-model="form.per_zip_code" is_zip is_num :disabled="form.ad_same"/>
        <TextControl :maxLength="3" ref="per_residence" label="Years of Residency" fieldId="per_residence" :required="!form.ad_same" v-model="form.per_residence" is_zip is_num :disabled="form.ad_same"/>
    </div>

    <div class="mt-8 xl:mt-16 flex flex-row gap-2 lg:gap-4">
        <ButtonControl theme="bg-white border-2 border-theme-primary text-theme-primary" rounded button_text="Back" disabled/>
        <ButtonControl theme="bg-primary border-2 border-theme-primary text-white" rounded button_text="Next" @click="$emit('next')" :disabled="!isFormComplete"/>
    </div>




  </div>
</template>

<script>
import TextControl from '@/components/controls/TextControl.vue';
import ComboBoxControl from '@/components/controls/ComboBoxControl.vue';
import DatePickerControl from '@/components/controls/DatePickerControl.vue';
import ButtonControl from '@/components/controls/ButtonControl.vue';

import User from '@/services/User';
import mixin from '@/mixin';

export default {
  name: 'v-tab-1',
  inject: ['setLoading'],
  mixins: [mixin],
  data() {
    return {
      validationErrors: {},
      cityPerOptions: [],
      cityPreOptions: [],
      cityPerLoading: false,
      cityPreLoading: false,
      form: {
        last_name: '',
        first_name: '',
        middle_name: '',
        suffix: '',
        account_no: '',
        member_key: '',
        id_code: '',
        id_number: '',
        id_expiry: '',
        tin: '',
        birth_date: '',
        birth_place: '',
        nationality: '',
        nationality_other: '',
        house_no: '',
        street: '',
        brgy: '',
        province: '',
        municipality: '',
        country: '',
        zip_code: '',
        residence: '',
        ad_same: false,
        per_house_no: '',
        per_street: '',
        per_brgy: '',
        per_province: '',
        per_municipality: '',
        per_country: '',
        per_zip_code: '',
        per_residence: '',
      },
    };
  },
  components: {
    TextControl,
    ComboBoxControl,
    DatePickerControl,
    ButtonControl
  },
  computed: {
    isFormComplete() {
        return (
          this.form.last_name &&
          this.form.first_name &&
          this.form.account_no &&
          this.form.member_key &&
          this.form.nationality &&

          this.form.id_code &&
          this.form.id_number &&
          this.form.id_expiry &&
          this.form.birth_date &&
          this.form.birth_place &&

          this.form.house_no &&
          this.form.street &&
          this.form.brgy &&
          this.form.province &&
          this.form.municipality &&
          this.form.country &&
          this.form.zip_code &&
          this.form.residence &&

          (
            this.form.ad_same ||
            (
              this.form.per_house_no &&
              this.form.per_street &&
              this.form.per_brgy &&
              this.form.per_province &&
              this.form.per_municipality &&
              this.form.per_country &&
              this.form.per_zip_code &&
              this.form.per_residence
            )
          )
        );
    },
    genderOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.gender) return [];

      return lookup.gender.map(g => ({
        label: g,
        value: g
      }));
    },
    countryOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.country) return [];

      return lookup.country.map(c => ({
        label: c,
        value: c
      }));
    },
    maritalStatusOptions() {
      const lookup = this.$store.state.lookup;
      if (!lookup || !lookup.marital_status) return [];

      return lookup.marital_status.map(ms => ({
        label: ms,
        value: ms
      }));
    },
    idOptions() {
      const nationality = this.$store.state.lookup?.list_of_ids;

      if (!Array.isArray(nationality)) return [];

      return nationality.map(item => ({
        label: item.bao_type,
        value: item.bao_code
      }));
    },
    nationalityOptions() {
      const nationality = this.$store.state.lookup?.nationality;

      if (!Array.isArray(nationality)) return [];

      return nationality.map(item => ({
        label: item.nationality,
        value: item.nationality
      }));
    },
    citizenshipOptions() {
      const nationality = this.$store.state.lookup?.nationality;

      if (!Array.isArray(nationality)) return [];

      return nationality.map(item => ({
        label: item.nationality,
        value: item.nationality
      }));
    },
    provinceOptions() {
      const provinces = this.$store.state.provinces;

      if (!Array.isArray(provinces)) return [];

      return provinces.map(p => ({
        label: p.province_name,
        value: p.province_code
      }));
    },
    isPhilippinesPre() {
      return this.form.country === 'PHILIPPINES';
    },
    isPhilippinesPer() {
      return this.form.per_country === 'PHILIPPINES';
    },
  },
  watch: {
    form: {
      deep: true,
      handler(newValue) {
        this.$store.commit('setFormDataPNB', newValue);
      },
    },
    'form.ad_same'(newValue) {
        if (newValue) {
          this.form.per_house_no = '';
          this.form.per_street = '';
          this.form.per_brgy = '';
          this.form.per_province = '';
          this.form.per_municipality = '';
          this.form.per_country = '';
          this.form.per_zip_code = '';
          this.form.per_residence = '';
        }
    },
    'form.province'(newProvince) {
      if (newProvince) {
        this.cityPreLoading = true;
        this.form.municipality = "";

        // console.log('Fetching cities for province:', newProvince);
        if (this.form.country == 'PHILIPPINES') {
          User.getCity(newProvince)
            .then((response) => {
              console.log('Cities fetched:', response.data.data);
              this.cityPreOptions = response.data.data.map(city => ({
                label: city.city_name,
                value: city.fcity_code
              }));
              this.cityPreLoading = false;
            })
            .catch((error) => {
              console.error('Error fetching cities:', error);
              this.cityPreLoading = false;
            });
        }

      }
    },
    'form.per_province'(newProvince) {
      if (newProvince) {
        this.cityPerLoading = true;
        this.form.per_city = "";

        // console.log('Fetching cities for province:', newProvince);
        if (this.form.per_country == 'PHILIPPINES') {
          User.getCity(newProvince)
            .then((response) => {
              console.log('Cities fetched:', response.data.data);
              this.cityPerOptions = response.data.data.map(city => ({
                label: city.city_name,
                value: city.fcity_code
              }));
              this.cityPerLoading = false;
            })
            .catch((error) => {
              console.error('Error fetching cities:', error);
              this.cityPerLoading = false;
            });
        }

      }
    },
    'form.country'() {
      // reset location fields when switching country
      this.form.province = "";
      this.form.municipality = "";
      this.form.brgy = "";

      this.cityOptions = [];
      this.brgyOptions = [];
    },
    'form.per_country'() {
      // reset location fields when switching country
      this.form.per_province = "";
      this.form.per_municipality = "";

      this.cityPerOptions = [];
    }
  },
  mounted() {
    this.restoreFormFromStore();
    this.autoFillFromCredentials();
    this.$store.commit('setFormDataPNB', this.form);
  },
  methods: {
    restoreFormFromStore() {
    const storeFormData = this.$store.state.formDataPNB || {};

    Object.keys(this.form).forEach((key) => {
      if (
        Object.prototype.hasOwnProperty.call(storeFormData, key) &&
        storeFormData[key] !== undefined &&
        storeFormData[key] !== null
      ) {
        this.form[key] = storeFormData[key];
      }
    });
  },

  autoFillFromCredentials() {
    const credentials = this.$store.state.credentials || {};

    const mappings = {
      last_name: "last_name",
      first_name: "first_name",
      middle_name: "middle_name",
      suffix: "suffix",
      account_no: "account_no",
      member_key: "key",
      tin: "tin",
      birth_date: "birthdate",
    };

    Object.entries(mappings).forEach(([formField, credentialField]) => {
      // Only autofill if the field is currently empty
      if (!this.form[formField] && credentials[credentialField] != null) {
        this.form[formField] = credentials[credentialField];
      }
    });
  },

  updateValidation(field, isValid) {
    this.validationErrors[field] = isValid;
  },
  },
};
</script>

<style scoped>
.papsi-grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 2rem;
}
.box {
  width: 4rem !important;
  height: 4rem !important;
  margin-right: 3rem !important; 
}
@media (max-width: 1000px) {
    .box {
      width: 2rem !important;
      height: 2rem !important;
      margin-right: 1rem !important;
      font-size:  5rem !important;
    }
    .agree {
      font-size: 1.7rem !important; 
    }
   

}

</style>